var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineaVerticale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1,
    height: 80,
    viewBox: "0 0 1 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5,80h-1V0h1Z",
    transform: "translate(0.5)",
    fill: "#dfe1e5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaVerticale);
export default __webpack_public_path__ + "static/media/linea-verticale.6754250b5ace95851c54c39ed7f779ee.svg";
export { ForwardRef as ReactComponent };